import { render, staticRenderFns } from "./IconNavigation.vue?vue&type=template&id=0dde6bce&scoped=true"
import script from "./IconNavigation.vue?vue&type=script&lang=js"
export * from "./IconNavigation.vue?vue&type=script&lang=js"
import style0 from "./IconNavigation.vue?vue&type=style&index=0&id=0dde6bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dde6bce",
  null
  
)

export default component.exports